import { useEffect, useState } from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

type Pending = { printer: string; resolve: (ok: boolean) => void };
let listener: ((p: Pending | null) => void) | null = null;

/** Ask the user to confirm printing to a non-Zebra printer. Resolves false if no host is mounted. */
export function confirmNonZebraPrinter(printer: string): Promise<boolean> {
  if (!listener) return Promise.resolve(window.confirm(
    `"${printer}" doesn't look like a Zebra label printer. Print anyway?`,
  ));
  return new Promise((resolve) => listener?.({ printer, resolve }));
}

export function LabelPrinterConfirmHost() {
  const [pending, setPending] = useState<Pending | null>(null);
  useEffect(() => {
    listener = setPending;
    return () => {
      listener = null;
    };
  }, []);

  const close = (ok: boolean) => {
    pending?.resolve(ok);
    setPending(null);
  };

  return (
    <AlertDialog open={!!pending} onOpenChange={(o) => !o && close(false)}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>This doesn't look like a Zebra label printer</AlertDialogTitle>
          <AlertDialogDescription>
            "{pending?.printer}" doesn't look like a Zebra label printer. Print anyway? This
            computer will remember your answer for this printer.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={() => close(false)}>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={() => close(true)}>Print anyway</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
